module.exports = __webpack_public_path__ + "static/media/emptyShield.e7db13ff.png";